/**
 * Created by zad on 17/9/27.
 */
// polyfill
import 'core-js/shim';
import 'raf/polyfill';

// start
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// styles
import '@jianshu/doyle/dist/doyle.css';
import './style/index.scss';
import '../node_modules/font-awesome/scss/font-awesome.scss';

import App from './App';
import ReduxRootStore from './store/ReduxRootStore';
import JsSensor from './sensorsdata/index';

const version = `v${process.env.VERSION}`;

// init sensor begin
window.JsSensor = new JsSensor({
  debug: false,
});
// init sensor end

const render = (AppContainer) => {
  ReactDOM.render(
    <Provider store={ReduxRootStore}>
      <AppContainer/>
    </Provider>,
    document.getElementById('root'),
  );
};

render(App);
window.__REACT__ = React; // eslint-disable-line no-underscore-dangle

// 模块热替换的 API
if (module.hot) {
  module.hot.accept(() => {
    render(App);
  });
}

// console the release version
if (window.console && typeof window.console.log === 'function') {
  console.log(`Release:: ${process.env.RELEASE || 'developing'}`);
  console.log(`Environment:: ${process.env.ENVIRONMENT}`);
  console.log(`Version:: ${version}`);
}



// WEBPACK FOOTER //
// ./src/index.js